import type { Prototype } from "../prototype-types";

export const sanjayRamanPrototypes: Prototype[] = [
  {
    id: "retailer-onboarding-brand-match",
    name: "Retailer Onboarding – Brand Match",
    path: "/sr/retailer-onboarding-brand-match",
    description:
      "Upload brand email list during new retailer onboarding; match to Faire (follow) vs not on Faire (referral). Step is skippable and placed in context of existing onboarding.",
    owner: "Sanjay",
    createdAt: "2026-02-27",
    lastUpdated: "2026-03-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2e558fdfdc0d8743ff1294fb792cb023a246a14676443262b237bcc21cc562db.png",
    creationTool: "cursor",
  },
];
